import { NewsItem } from '../../core/models/types';

export function sponsorAmount(amount: number): string {
  const millions = Math.max(1, Math.round(amount / 1_000_000));
  const rounded = millions * 1_000_000;
  const qualifier = rounded > amount ? 'casi ' : rounded < amount ? 'más de ' : '';
  return `por ${qualifier}${millions.toLocaleString('es-ES')} ${millions === 1 ? 'millón' : 'millones'} de euros`;
}

export function newsSponsorTitle(item: NewsItem) {
  if (item.type !== 'private.economy.sponsor-signed.v1') return null;
  const source = item.facts?.['source'];
  const clubId = source?.clubId;
  const clubName = item.facts?.['names']?.[clubId];
  const sponsorName = source?.terms?.name;
  const rawAmount = source?.terms?.quote?.finalFixed;
  const amount = Number(rawAmount);
  if (!clubId || !clubName || !sponsorName || rawAmount == null || !Number.isFinite(amount) || amount < 0) return null;
  let websiteUrl: string | null = null;
  try {
    const url = new URL(item.facts?.['sponsorWebsiteUrl'] || source?.terms?.websiteUrl);
    if (url.protocol === 'https:' || url.protocol === 'http:') websiteUrl = url.href;
  } catch { /* A missing or invalid URL leaves the sponsor as italic text. */ }
  return { clubId, clubName, sponsorName, websiteUrl,
    amount: amount === 0 ? 'por 0 euros' : sponsorAmount(amount) };
}
